<template lang="html">
  <div class="card" :style="selfStyle">
    <div class="card-body">
      <div class="card-header">
        友情链接
      </div>
      <ul class="card-content">
        <li class="card-content-item" :key="item.id" v-for="item in datas">
          <a :href="item.url" >{{item.label}}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'selfStyle'
  ],
  data () {
    return {
      datas: [
        {
          id: 1,
          label: '复星官网',
          url: 'https://www.fosun.com/'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/font/iconfont.css';
.card {
  box-sizing: border-box;
  padding: 0 7.5px;
  margin-bottom: 65px;
  width: 100%;
  border-radius: 2px;
  .card-body {
    background-color: #fff;
    .card-header {
      height: 50px;
      line-height: 50px;
      padding: 0 15px;
      border-bottom: 1px dotted #E9E9E9;
      color: #333;
      border-radius: 2px 2px 0 0;
      font-size: 14px;
    }
    .card-content {
      padding: 10px 15px;
      .card-content-item {
        display:inline-block;
        line-height: 26px;
        list-style-position: inside;
        list-style-type: disc;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        list-style: none;
        font-size: 12px;
        color: #ccc;
        padding-right: 15px;
        a {
          max-width: 85%;
          margin-right: 5px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 14px;
          text-decoration: none;
          color: #333;
        }
        span {
          margin-right: 5px;
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .card {
    padding:0 7.5px !important;
  }
}
</style>
